import React from 'react';
import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import { useContext as useUsersContext } from 'components/Users/Context';
import { useContext } from 'components/Members/Programs/Views/Show/Context';
import Form from 'components/Members/LearningStyle/Widgets/LearningStyleForm/Index';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

export default function Index() {
  const navigate = useNavigate();
  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();
  const { state } = useContext();

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  return (
    <>
      <StepTab
        total={state.program.attributes.is_first_assessment_needed ? 5 : 4}
        current={state.program.attributes.is_first_assessment_needed ? 3 : 2}
      />

      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Learning Style</h1>

          <p>
            Part of matching with the right coach is understanding how you learn best.
            Don&apos;t think too deeply about each question. Your gut reaction is what we want to capture.
          </p>
        </section>

        <Form
          submitText="Next"
          afterSubmit={() => {
            actionsUsers.load(dispatchUsers);

            navigate(routes.members.programs.new.myPreferences(state.program.id));
          }}
          previousLink={routes.members.programs.new.orderTopics(state.program.id)}
        />
      </div>
    </>
  );
}
